<div class="edit-point">
  <div class="loader" *ngIf="isLoading">
    <app-loading-spinner></app-loading-spinner>
  </div>
  <div class="header-edit">
    <div class="title">
      Édition du point {{ point.title }}
    </div>
  </div>
  <div class="breadcrumb">
    <span (click)=goBack()>< Revenir à mes points</span>
  </div>
  <div class="map">
    <div id="map">
    </div>
  </div>
  <div class="contenu">
    <div class="formulaire">
      <div class="content-current-point">
        <div class="titles">
          <div class="google" *ngIf="googleInfos">
            Informations issues de Google
          </div>
          <div class="perso" [ngClass]="{'full-width':!googleInfos}">
            Vos informations
          </div>
        </div>
        <div class="name">
          <div class="google" *ngIf="googleInfos">
            <div class="input-title">
              Nom du point
            </div>
            <div class="input">
              {{ googleInfos.title }}
            </div>
          </div>
          <div class="copy" *ngIf="googleInfos">
            <div class="icone" (click)="onCopyData(googleInfos.title, 'title')">
              <div class="triangle">
                <svg height="512pt" viewBox="-56 0 512 512" width="512pt" xmlns="http://www.w3.org/2000/svg"><path d="m395.980469 112.582031-108.023438-108.023437c-2.960937-2.960938-6.949219-4.558594-11.019531-4.558594h-156.339844c-8.597656 0-15.578125 6.980469-15.578125 15.578125v89.445313h-89.441406c-8.597656 0-15.578125 6.976562-15.578125 15.578124v375.820313c0 8.597656 6.980469 15.578125 15.578125 15.578125h264.359375c8.601562 0 15.582031-6.980469 15.582031-15.578125v-89.445313h89.441407c8.597656 0 15.578124-6.976562 15.578124-15.578124v-267.796876c0-3.960937-1.523437-7.984374-4.558593-11.019531zm-26.597657 263.238281h-73.863281v-147.195312c0-4.035156-1.570312-8.03125-4.5625-11.023438l-108.019531-108.019531c-2.933594-2.9375-6.914062-4.5625-11.019531-4.5625h-35.738281v-73.863281h125.179687v92.445312c0 8.597657 6.980469 15.578126 15.578125 15.578126h92.445312zm-105.023437 105.023438h-233.203125v-344.664062h125.179688v92.445312c0 8.597656 6.980468 15.578125 15.582031 15.578125h92.441406zm-76.863281-322.636719 54.835937 54.835938h-54.835937zm159.855468-50.183593h-54.835937v-54.835938c6.855469 6.851562 49.367187 49.367188 54.835937 54.835938zm0 0"/></svg>
              </div>
            </div>
          </div>
          <div class="perso" [ngClass]="{'full-width':!googleInfos}">
            <div class="input-title">
              Nom du point
            </div>
            <div class="input">
              <input
                type="text"
                placeholder="Nom du point"
                [(ngModel)]="title"
                />
            </div>
          </div>
        </div>
        <!-- <div class="facultatif">
          <div class="line"></div>
          <div class="text">
            Facultatif
          </div>
        </div> -->
        <div class="description">
          <div class="perso" [ngClass]="{'full-width':!googleInfos}">
            <div class="input-title">
              Description
            </div>
            <quill-editor
              [(ngModel)]="description"
              [theme]="'bubble'"
              [modules]="{
                toolbar: false
              }"
              [formats]="['bold', 'link']"
              [placeholder]="'Description...'"
            >
            </quill-editor>
          </div>
        </div>
        <div class="moreinfos">
          <div class="google" *ngIf="googleInfos">
            <div class="input-title">
              Informations complémentaires
            </div>
            <div class="input textarea">
              {{ googleInfos.more }}
            </div>
          </div>
          <div class="copy center" *ngIf="googleInfos">
            <div class="icone" (click)="onCopyData(googleInfos.more, 'moreinfo')">
              <div class="triangle">
                <svg height="512pt" viewBox="-56 0 512 512" width="512pt" xmlns="http://www.w3.org/2000/svg"><path d="m395.980469 112.582031-108.023438-108.023437c-2.960937-2.960938-6.949219-4.558594-11.019531-4.558594h-156.339844c-8.597656 0-15.578125 6.980469-15.578125 15.578125v89.445313h-89.441406c-8.597656 0-15.578125 6.976562-15.578125 15.578124v375.820313c0 8.597656 6.980469 15.578125 15.578125 15.578125h264.359375c8.601562 0 15.582031-6.980469 15.582031-15.578125v-89.445313h89.441407c8.597656 0 15.578124-6.976562 15.578124-15.578124v-267.796876c0-3.960937-1.523437-7.984374-4.558593-11.019531zm-26.597657 263.238281h-73.863281v-147.195312c0-4.035156-1.570312-8.03125-4.5625-11.023438l-108.019531-108.019531c-2.933594-2.9375-6.914062-4.5625-11.019531-4.5625h-35.738281v-73.863281h125.179687v92.445312c0 8.597657 6.980469 15.578126 15.578125 15.578126h92.445312zm-105.023437 105.023438h-233.203125v-344.664062h125.179688v92.445312c0 8.597656 6.980468 15.578125 15.582031 15.578125h92.441406zm-76.863281-322.636719 54.835937 54.835938h-54.835937zm159.855468-50.183593h-54.835937v-54.835938c6.855469 6.851562 49.367187 49.367188 54.835937 54.835938zm0 0"/></svg>
              </div>
            </div>
          </div>
          <div class="perso" [ngClass]="{'full-width':!googleInfos}">
            <div class="input-title">
              Informations complémentaires <span>(horaires, prix, ...)</span>
            </div>
            <div class="input">
              <textarea
                rows="4"
                placeholder="Informations complémentaires"
                [(ngModel)]="moreinfo"
                ></textarea>
            </div>
          </div>
        </div>
        <div class="categorie">
          <div class="google" *ngIf="googleInfos">
          </div>
          <div class="perso" [ngClass]="{'full-width':!googleInfos}">
            <div class="title">
              Ajouter une catégorie
            </div>
            <div class="add-cat">
              <select [(ngModel)]="categorie">
                <option value="" [attr.selected]="categorie ? null : 'selected'">
                  Sans catégorie
                </option>
                <option *ngFor="let cat of categories" [value]="cat.id" [attr.selected]="cat.id == categorie ? 'selected' : null">
                  {{ cat.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="images">
          <div class="google" *ngIf="googleInfos">
            <div class="title">
              Images
            </div>
            <div class="content" *ngIf="googleInfos.medias">
              <div class="image" *ngFor="let media of googleInfos.medias">
                <img src="{{media}}" alt="">
                <div class="copy" (click)="onCopyImage(media)">
                  <svg height="512pt" viewBox="-56 0 512 512" width="512pt" xmlns="http://www.w3.org/2000/svg"><path d="m395.980469 112.582031-108.023438-108.023437c-2.960937-2.960938-6.949219-4.558594-11.019531-4.558594h-156.339844c-8.597656 0-15.578125 6.980469-15.578125 15.578125v89.445313h-89.441406c-8.597656 0-15.578125 6.976562-15.578125 15.578124v375.820313c0 8.597656 6.980469 15.578125 15.578125 15.578125h264.359375c8.601562 0 15.582031-6.980469 15.582031-15.578125v-89.445313h89.441407c8.597656 0 15.578124-6.976562 15.578124-15.578124v-267.796876c0-3.960937-1.523437-7.984374-4.558593-11.019531zm-26.597657 263.238281h-73.863281v-147.195312c0-4.035156-1.570312-8.03125-4.5625-11.023438l-108.019531-108.019531c-2.933594-2.9375-6.914062-4.5625-11.019531-4.5625h-35.738281v-73.863281h125.179687v92.445312c0 8.597657 6.980469 15.578126 15.578125 15.578126h92.445312zm-105.023437 105.023438h-233.203125v-344.664062h125.179688v92.445312c0 8.597656 6.980468 15.578125 15.582031 15.578125h92.441406zm-76.863281-322.636719 54.835937 54.835938h-54.835937zm159.855468-50.183593h-54.835937v-54.835938c6.855469 6.851562 49.367187 49.367188 54.835937 54.835938zm0 0"/></svg>
                </div>
              </div>
            </div>
            <div class="no-content" *ngIf="!googleInfos.medias">
              Aucune image issue de Google
            </div>
          </div>
          <div class="perso" [ngClass]="{'full-width':!googleInfos}">
            <div class="title">
              Images
            </div>
            <div class="subtitle">
              La première image constitue la bannière du point. Elle est obligatoire.
            </div>
            <div class="content">
              <div class="custom-dropzone" ngx-dropzone [accept]="'image/*'" (change)="onSelect($event)">
                <ngx-dropzone-label>
                  <div class="label">Glissez ou cliquez pour déposer des images</div>
                </ngx-dropzone-label>
                <ngx-dropzone-image-preview ngProjectAs="ngx-dropzone-preview" *ngFor="let f of filesImage" [file]="f" [removable]="true" (removed)="onRemove(f)">
                  <ngx-dropzone-label>
                    <span>{{ f.name }}</span>
                    <div class="edit" (click)="onCropImg(f);$event.stopPropagation()">
                      <svg width="22px" height="22px" viewBox="0 0 22 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <g id="Icons" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                          <g id="Two-Tone" transform="translate(-577.000000, -2725.000000)">
                            <g id="Image" transform="translate(100.000000, 2626.000000)">
                              <g id="Two-Tone-/-Image-/-crop" transform="translate(476.000000, 98.000000)">
                                <g>
                                  <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
                                  <path d="M5,17 C5,18.1 5.9,19 7,19 L17,19 L17,23 L19,23 L19,19 L23,19 L23,17 L7,17 L7,1 L5,1 L5,5 L1,5 L1,7 L5,7 L5,17 Z M19,15 L19,7 C19,5.9 18.1,5 17,5 L9,5 L9,7 L17,7 L17,15 L19,15 Z" fill="#FFF"></path>
                                </g>
                              </g>
                            </g>
                          </g>
                        </g>
                      </svg>
                    </div>
                  </ngx-dropzone-label>
                </ngx-dropzone-image-preview>
              </div>
            </div>
          </div>
        </div>
        <div class="cropper" *ngIf="cropImg">
          <app-img-cropper (fileCropped)="onCroppedImg($event)" [img]="imgToCrop" [isModal]="false"></app-img-cropper>
        </div>
        <div class="customicon">
          <div class="title">
            Icône du point
          </div>
          <div class="subtitle">
            L'icône du point sera utilisée sur la carte pour indiquer le point
          </div>
          <div class="content">
            <div class="custom-dropzone" ngx-dropzone [accept]="'image/*'" (change)="onSelectIcon($event)">
              <ngx-dropzone-label>
                <div class="label">Glissez ou cliquez pour déposer une image</div>
              </ngx-dropzone-label>
              <ngx-dropzone-image-preview ngProjectAs="ngx-dropzone-preview" *ngFor="let f of filesIcon" [file]="f" [removable]="true" (removed)="onRemoveIcon(f)">
                <ngx-dropzone-label>
                  <span>{{ f.name }}</span>
                </ngx-dropzone-label>
              </ngx-dropzone-image-preview>
            </div>
          </div>
        </div>
        <div class="sound">
          <div class="title">
            Ajouter un fichier audio
          </div>
          <div class="custom-dropzone" ngx-dropzone [accept]="'audio/mp3, audio/mpeg'" (change)="onSelectSound($event)">
            <ngx-dropzone-label>
              <div class="label">Glissez ou cliquez pour déposer un son (MP3)</div>
            </ngx-dropzone-label>
            <ngx-dropzone-preview ngProjectAs="ngx-dropzone-preview" *ngFor="let f of filesSound" [file]="f" [removable]="true" (removed)="onRemoveSound(f)">
              <ngx-dropzone-label>{{ f.name }}</ngx-dropzone-label>
            </ngx-dropzone-preview>
          </div>
        </div>
        <div class="video">
          <div class="title">
            Ajouter une vidéo
          </div>
          <div class="ajouter-video">
            <div class="from-user" *ngIf="!videoType">
              <div class="custom-dropzone" ngx-dropzone [accept]="'video/mp4'" (change)="onSelectVideo($event)">
                <ngx-dropzone-label>
                  <div class="label">Glissez ou cliquez pour déposer une vidéo depuis votre ordinateur</div>
                </ngx-dropzone-label>
                <ngx-dropzone-preview ngProjectAs="ngx-dropzone-preview" *ngFor="let f of filesVideo" [file]="f" [removable]="true" (removed)="onRemoveVideo(f)">
                  <ngx-dropzone-label>{{ f.name }}</ngx-dropzone-label>
                </ngx-dropzone-preview>
              </div>
            </div>
            <div class="or" *ngIf="!filesVideo.length && !videoType">
              Ou
            </div>
            <div class="choices" *ngIf="!filesVideo.length && !videoType">
              <div class="choice youtube" (click)="addVideo(1)">
                <div class="icone">
                  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                    viewBox="0 0 473.931 473.931" style="enable-background:new 0 0 473.931 473.931;" xml:space="preserve">
                    <circle style="fill:#D42428;" cx="236.966" cy="236.966" r="236.966"/>
                    <path style="fill:#CC202D;" d="M404.518,69.38c92.541,92.549,92.549,242.593,0,335.142c-92.541,92.541-242.593,92.545-335.142,0
                    L404.518,69.38z"/>
                    <path style="fill:#BA202E;" d="M470.321,277.964L310.843,118.487l-12.864,12.864l-12.864-12.864l-14.099,14.099l9.47,9.47
                    l-3.091,3.091l-24.557-24.557l-1.048,1.055l-33.092-33.092l-14.099,14.099l3.858,3.858l-5.665,5.665l-23.854-23.854l-9.889,9.889
                    l23.255,56.003l-10.473,42.997l28.632,28.639l-72.418,5.066l-1.096,125.667l116.537,116.679
                    C362.678,465.505,451.836,383.833,470.321,277.964z"/>
                    <path style="fill:#FFFFFF;" d="M321.724,291.91h-15.289l0.075-8.875c0-3.948,3.237-7.169,7.199-7.169h0.98
                    c3.963,0,7.214,3.222,7.214,7.169L321.724,291.91z M264.404,272.89c-3.865,0-7.038,2.608-7.038,5.796v43.161
                    c0,3.188,3.173,5.781,7.038,5.781c3.895,0,7.068-2.593,7.068-5.781v-43.165C271.472,275.498,268.299,272.89,264.404,272.89z
                    M357.473,248.752v82.102c0,19.697-17.077,35.809-37.96,35.809H163.444c-20.887,0-37.96-16.116-37.96-35.809v-82.102
                    c0-19.697,17.074-35.816,37.96-35.816h156.073C340.395,212.936,357.473,229.059,357.473,248.752z M173.85,339.771l-0.007-86.487
                    l19.345,0.007v-12.819l-51.573-0.079v12.595l16.101,0.049v86.73h16.134V339.771z M231.847,266.17h-16.131v46.181
                    c0,6.683,0.4,10.024-0.022,11.199c-1.317,3.581-7.214,7.383-9.508,0.389c-0.389-1.227-0.045-4.924-0.052-11.274l-0.075-46.499
                    h-16.041l0.06,45.765c0.007,7.016-0.161,12.247,0.052,14.627c0.393,4.198,0.247,9.096,4.15,11.884
                    c7.252,5.235,21.163-0.778,24.643-8.251l-0.03,9.534l12.95,0.019V266.17H231.847z M283.45,319.052l-0.03-38.439
                    c-0.015-14.653-10.971-23.427-25.856-11.573l0.067-28.58l-16.116,0.026l-0.079,98.637l13.25-0.195l1.205-6.148
                    C272.83,348.332,283.479,337.683,283.45,319.052z M333.941,313.96l-12.101,0.064c0,0.483-0.022,1.033-0.03,1.639v6.75
                    c0,3.611-2.982,6.552-6.608,6.552h-2.369c-3.633,0-6.615-2.941-6.615-6.552v-0.748v-7.431v-9.579h27.697V294.23
                    c0-7.614-0.198-15.229-0.827-19.584c-1.979-13.781-21.317-15.966-31.09-8.913c-3.068,2.204-5.407,5.152-6.776,9.119
                    c-1.373,3.963-2.054,9.369-2.054,16.247v22.918C293.178,352.115,339.452,346.73,333.941,313.96z M271.895,189.524
                    c0.827,2.028,2.118,3.663,3.88,4.905c1.725,1.212,3.948,1.83,6.6,1.83c2.324,0,4.385-0.629,6.174-1.927
                    c1.792-1.291,3.304-3.214,4.531-5.788l-0.307,6.331h17.979v-76.467h-14.155v59.513c0,3.218-2.66,5.856-5.905,5.856
                    c-3.222,0-5.89-2.638-5.89-5.856v-59.513h-14.769v51.573c0,6.571,0.116,10.952,0.314,13.175
                    C270.559,185.363,271.064,187.477,271.895,189.524z M217.408,146.337c0-7.341,0.614-13.07,1.826-17.201
                    c1.22-4.12,3.427-7.431,6.608-9.923c3.18-2.511,7.252-3.764,12.191-3.764c4.157,0,7.723,0.819,10.705,2.417
                    c2.982,1.609,5.298,3.693,6.892,6.271c1.639,2.586,2.739,5.246,3.334,7.966c0.606,2.754,0.898,6.919,0.898,12.52v19.341
                    c0,7.094-0.284,12.31-0.834,15.626c-0.543,3.323-1.717,6.402-3.536,9.287c-1.796,2.859-4.116,4.995-6.93,6.357
                    c-2.836,1.381-6.08,2.054-9.755,2.054c-4.093,0-7.551-0.565-10.391-1.751c-2.851-1.175-5.059-2.949-6.627-5.302
                    c-1.594-2.357-2.705-5.227-3.375-8.572c-0.681-3.349-1.003-8.374-1.003-15.079v-20.247H217.408z M231.484,176.716
                    c0,4.325,3.229,7.861,7.154,7.861s7.132-3.532,7.132-7.861v-40.71c0-4.325-3.207-7.861-7.132-7.861s-7.154,3.532-7.154,7.861
                    V176.716z M181.722,197.269h16.969l0.015-58.648l20.045-50.241h-18.555l-10.657,37.324l-10.81-37.421h-18.357l21.324,50.372
                    L181.722,197.269z"/>
                  </svg>
                </div>
                <div class="titre">
                  Youtube
                </div>
              </div>
              <div class="choice vimeo" (click)="addVideo(2)">
                <div class="icone">
                  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                      viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                    <circle style="fill:#65A2D9;" cx="256" cy="256" r="256"/>
                    <path style="fill:#3A7CA5;" d="M388.741,143.1c-14.305,27.281-24.457,56.289-35.357,85.626
                      c-15.398-17.534-27.851-31.056-27.851-31.056h-42.696l-56.832-56.83l31.923,119.672l-91.57-67.722l-49.145,27.405l142.745,142.745
                      c-8.945,3.024-18.642,5.491-28.691,8.697L352.711,493.08c90.474-36.945,155.064-124.159,159.07-226.94L388.741,143.1z"/>
                    <path style="fill:#FFFFFF;" d="M390.401,144.762c-7.096-7.646-17.368-11.717-30.527-12.104c-37.152-1.2-63.426,18.566-78.091,58.733
                      c-0.769,2.11-0.3,4.451,1.226,6.106c1.517,1.645,3.796,2.301,5.947,1.71c4.22-1.16,8.401-1.746,12.435-1.746
                      c5.413,0,12.621,0.995,16.208,5.735c2.75,3.641,3.125,9.097,1.11,16.219c-1.698,6.011-10.449,22.097-21.28,39.117
                      c-13.195,20.739-20.482,30.036-22.585,30.036c-6.959,0-32.116-111.547-32.809-113.993c-7.213-25.566-10.836-38.398-34.299-38.398
                      c-17.884,0-57.768,32.658-90.517,61.109c-2.015,1.746-3.71,3.22-5.022,4.346c-3.165,2.707-3.643,7.404-1.088,10.702l6.103,7.859
                      c2.572,3.313,7.259,4.006,10.68,1.576l0.336-0.241c10.593-7.537,20.604-14.655,28.16-15.048
                      c8.209-0.402,15.334,12.428,23.828,42.951c16.175,59.289,40.755,129.96,65.977,129.96c26.357,0,57.804-22.344,98.451-75.242
                      c36.788-47.875,56.489-85.845,57.751-113.473C403.346,169.817,399.31,154.365,390.401,144.762L390.401,144.762z"/>
                    <path style="fill:#D1D1D1;" d="M390.401,144.762c-7.096-7.646-17.368-11.717-30.527-12.104c-37.152-1.2-63.426,18.566-78.091,58.733
                      c-0.769,2.11-0.3,4.451,1.226,6.106c1.517,1.645,3.796,2.301,5.947,1.71c4.22-1.16,8.401-1.746,12.435-1.746
                      c5.413,0,12.621,0.995,16.208,5.735c2.75,3.641,3.125,9.097,1.11,16.219c-1.698,6.011-10.449,22.097-21.28,39.117
                      c-13.195,20.739-20.482,30.036-22.585,30.036c-3.587,0-12.007-29.625-19.42-58.675v148.599
                      c24.426-4.613,53.212-27.479,89.219-74.342c36.788-47.875,56.489-85.845,57.751-113.473
                      C403.346,169.817,399.31,154.365,390.401,144.762z"/>
                  </svg>
                </div>
                <div class="titre">
                  Vimeo
                </div>
              </div>
              <div class="choice facebook" (click)="addVideo(3)">
                <div class="icone">
                  <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                      viewBox="0 0 112.196 112.196" style="enable-background:new 0 0 112.196 112.196;" xml:space="preserve">
                    <g>
                      <circle style="fill:#3B5998;" cx="56.098" cy="56.098" r="56.098"/>
                      <path style="fill:#FFFFFF;" d="M70.201,58.294h-10.01v36.672H45.025V58.294h-7.213V45.406h7.213v-8.34
                        c0-5.964,2.833-15.303,15.301-15.303L71.56,21.81v12.51h-8.151c-1.337,0-3.217,0.668-3.217,3.513v7.585h11.334L70.201,58.294z"/>
                    </g>
                  </svg>
                </div>
                <div class="titre">
                  Facebook
                </div>
              </div>
              <div class="choice embed" (click)="addVideo(4)">
                <div class="icone">
                  <svg height="512" viewBox="0 0 128 128" width="512" xmlns="http://www.w3.org/2000/svg"><g id="number"><text fill="#24253a" font-family="MyriadPro-Regular, Myriad Pro" font-size="40" letter-spacing=".002em" transform="translate(61.012 -738.265)">8<tspan x="-10.3" y="228">18</tspan><tspan x="-10.3" y="456">28</tspan><tspan x="-10.3" y="684">38</tspan><tspan x="-10.3" y="912">48</tspan><tspan x="-10.3" y="1140">58</tspan><tspan x="-10.3" y="1368">68</tspan><tspan x="-10.3" y="1596">78</tspan><tspan x="-10.3" y="1824">88</tspan><tspan x="-10.3" y="2052">98</tspan><tspan x="-20.599" y="2280">108</tspan><tspan x="-20.599" y="2508">118</tspan><tspan x="-20.599" y="2736">128</tspan><tspan x="-20.599" y="2964">138</tspan><tspan x="-20.599" y="3192">148</tspan><tspan x="-20.599" y="3420">158</tspan><tspan x="-20.599" y="3648">168</tspan><tspan x="-20.599" y="3876">178</tspan><tspan x="-20.599" y="4104">188</tspan><tspan x="-20.599" y="4332">198</tspan><tspan x="-20.599" y="4560">208</tspan><tspan x="-20.599" y="4788">218</tspan><tspan x="-20.599" y="5016">228</tspan><tspan x="-20.599" y="5244">238</tspan><tspan x="-20.599" y="5472">248</tspan></text></g><g id="Circle_Grid" data-name="Circle Grid"><circle cx="64" cy="64" fill="#f6c863" r="64"/></g><g id="icon"><path d="m29.587 36.85h68.83a1.645 1.645 0 0 1 1.645 1.645v48.54a0 0 0 0 1 0 0h-72.12a0 0 0 0 1 0 0v-48.535a1.645 1.645 0 0 1 1.645-1.65z" fill="#575b6d"/><path d="m45.08 27.939h37.845v63.894h-37.845z" fill="#69b0ee" transform="matrix(0 1 -1 0 123.889 -4.116)"/><path d="m105 83.922v1.609a5.618 5.618 0 0 1 -1.645 3.972 5.618 5.618 0 0 1 -3.972 1.645h-70.783a5.572 5.572 0 0 1 -3.944-1.636l-.03-.03a5.572 5.572 0 0 1 -1.626-3.934v-1.626a1 1 0 0 1 1-1h31.983a.411.411 0 0 1 .411.411 3.291 3.291 0 0 0 3.291 3.291h8.639a3.291 3.291 0 0 0 3.291-3.291.411.411 0 0 1 .411-.411h31.974a1 1 0 0 1 1 1z" fill="#414451"/><g fill="#eeefee"><path d="m77.172 40.96-13.125 37.85h-1.74l13.125-37.85z" opacity=".5"/><path d="m70.196 40.96-13.125 37.85h-6.243l13.125-37.85z" opacity=".5"/></g></g></svg>
                </div>
                <div class="titre">
                  Depuis un code embed
                </div>
              </div>
            </div>
            <div class="new-code"*ngIf="videoType">
              <div class="input">
                <div *ngIf="videoType == 1" class="icone">
                  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                    viewBox="0 0 473.931 473.931" style="enable-background:new 0 0 473.931 473.931;" xml:space="preserve">
                    <circle style="fill:#D42428;" cx="236.966" cy="236.966" r="236.966"/>
                    <path style="fill:#CC202D;" d="M404.518,69.38c92.541,92.549,92.549,242.593,0,335.142c-92.541,92.541-242.593,92.545-335.142,0
                    L404.518,69.38z"/>
                    <path style="fill:#BA202E;" d="M470.321,277.964L310.843,118.487l-12.864,12.864l-12.864-12.864l-14.099,14.099l9.47,9.47
                    l-3.091,3.091l-24.557-24.557l-1.048,1.055l-33.092-33.092l-14.099,14.099l3.858,3.858l-5.665,5.665l-23.854-23.854l-9.889,9.889
                    l23.255,56.003l-10.473,42.997l28.632,28.639l-72.418,5.066l-1.096,125.667l116.537,116.679
                    C362.678,465.505,451.836,383.833,470.321,277.964z"/>
                    <path style="fill:#FFFFFF;" d="M321.724,291.91h-15.289l0.075-8.875c0-3.948,3.237-7.169,7.199-7.169h0.98
                    c3.963,0,7.214,3.222,7.214,7.169L321.724,291.91z M264.404,272.89c-3.865,0-7.038,2.608-7.038,5.796v43.161
                    c0,3.188,3.173,5.781,7.038,5.781c3.895,0,7.068-2.593,7.068-5.781v-43.165C271.472,275.498,268.299,272.89,264.404,272.89z
                    M357.473,248.752v82.102c0,19.697-17.077,35.809-37.96,35.809H163.444c-20.887,0-37.96-16.116-37.96-35.809v-82.102
                    c0-19.697,17.074-35.816,37.96-35.816h156.073C340.395,212.936,357.473,229.059,357.473,248.752z M173.85,339.771l-0.007-86.487
                    l19.345,0.007v-12.819l-51.573-0.079v12.595l16.101,0.049v86.73h16.134V339.771z M231.847,266.17h-16.131v46.181
                    c0,6.683,0.4,10.024-0.022,11.199c-1.317,3.581-7.214,7.383-9.508,0.389c-0.389-1.227-0.045-4.924-0.052-11.274l-0.075-46.499
                    h-16.041l0.06,45.765c0.007,7.016-0.161,12.247,0.052,14.627c0.393,4.198,0.247,9.096,4.15,11.884
                    c7.252,5.235,21.163-0.778,24.643-8.251l-0.03,9.534l12.95,0.019V266.17H231.847z M283.45,319.052l-0.03-38.439
                    c-0.015-14.653-10.971-23.427-25.856-11.573l0.067-28.58l-16.116,0.026l-0.079,98.637l13.25-0.195l1.205-6.148
                    C272.83,348.332,283.479,337.683,283.45,319.052z M333.941,313.96l-12.101,0.064c0,0.483-0.022,1.033-0.03,1.639v6.75
                    c0,3.611-2.982,6.552-6.608,6.552h-2.369c-3.633,0-6.615-2.941-6.615-6.552v-0.748v-7.431v-9.579h27.697V294.23
                    c0-7.614-0.198-15.229-0.827-19.584c-1.979-13.781-21.317-15.966-31.09-8.913c-3.068,2.204-5.407,5.152-6.776,9.119
                    c-1.373,3.963-2.054,9.369-2.054,16.247v22.918C293.178,352.115,339.452,346.73,333.941,313.96z M271.895,189.524
                    c0.827,2.028,2.118,3.663,3.88,4.905c1.725,1.212,3.948,1.83,6.6,1.83c2.324,0,4.385-0.629,6.174-1.927
                    c1.792-1.291,3.304-3.214,4.531-5.788l-0.307,6.331h17.979v-76.467h-14.155v59.513c0,3.218-2.66,5.856-5.905,5.856
                    c-3.222,0-5.89-2.638-5.89-5.856v-59.513h-14.769v51.573c0,6.571,0.116,10.952,0.314,13.175
                    C270.559,185.363,271.064,187.477,271.895,189.524z M217.408,146.337c0-7.341,0.614-13.07,1.826-17.201
                    c1.22-4.12,3.427-7.431,6.608-9.923c3.18-2.511,7.252-3.764,12.191-3.764c4.157,0,7.723,0.819,10.705,2.417
                    c2.982,1.609,5.298,3.693,6.892,6.271c1.639,2.586,2.739,5.246,3.334,7.966c0.606,2.754,0.898,6.919,0.898,12.52v19.341
                    c0,7.094-0.284,12.31-0.834,15.626c-0.543,3.323-1.717,6.402-3.536,9.287c-1.796,2.859-4.116,4.995-6.93,6.357
                    c-2.836,1.381-6.08,2.054-9.755,2.054c-4.093,0-7.551-0.565-10.391-1.751c-2.851-1.175-5.059-2.949-6.627-5.302
                    c-1.594-2.357-2.705-5.227-3.375-8.572c-0.681-3.349-1.003-8.374-1.003-15.079v-20.247H217.408z M231.484,176.716
                    c0,4.325,3.229,7.861,7.154,7.861s7.132-3.532,7.132-7.861v-40.71c0-4.325-3.207-7.861-7.132-7.861s-7.154,3.532-7.154,7.861
                    V176.716z M181.722,197.269h16.969l0.015-58.648l20.045-50.241h-18.555l-10.657,37.324l-10.81-37.421h-18.357l21.324,50.372
                    L181.722,197.269z"/>
                  </svg>
                </div>
                <div *ngIf="videoType == 2" class="icone">
                  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                      viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                    <circle style="fill:#65A2D9;" cx="256" cy="256" r="256"/>
                    <path style="fill:#3A7CA5;" d="M388.741,143.1c-14.305,27.281-24.457,56.289-35.357,85.626
                      c-15.398-17.534-27.851-31.056-27.851-31.056h-42.696l-56.832-56.83l31.923,119.672l-91.57-67.722l-49.145,27.405l142.745,142.745
                      c-8.945,3.024-18.642,5.491-28.691,8.697L352.711,493.08c90.474-36.945,155.064-124.159,159.07-226.94L388.741,143.1z"/>
                    <path style="fill:#FFFFFF;" d="M390.401,144.762c-7.096-7.646-17.368-11.717-30.527-12.104c-37.152-1.2-63.426,18.566-78.091,58.733
                      c-0.769,2.11-0.3,4.451,1.226,6.106c1.517,1.645,3.796,2.301,5.947,1.71c4.22-1.16,8.401-1.746,12.435-1.746
                      c5.413,0,12.621,0.995,16.208,5.735c2.75,3.641,3.125,9.097,1.11,16.219c-1.698,6.011-10.449,22.097-21.28,39.117
                      c-13.195,20.739-20.482,30.036-22.585,30.036c-6.959,0-32.116-111.547-32.809-113.993c-7.213-25.566-10.836-38.398-34.299-38.398
                      c-17.884,0-57.768,32.658-90.517,61.109c-2.015,1.746-3.71,3.22-5.022,4.346c-3.165,2.707-3.643,7.404-1.088,10.702l6.103,7.859
                      c2.572,3.313,7.259,4.006,10.68,1.576l0.336-0.241c10.593-7.537,20.604-14.655,28.16-15.048
                      c8.209-0.402,15.334,12.428,23.828,42.951c16.175,59.289,40.755,129.96,65.977,129.96c26.357,0,57.804-22.344,98.451-75.242
                      c36.788-47.875,56.489-85.845,57.751-113.473C403.346,169.817,399.31,154.365,390.401,144.762L390.401,144.762z"/>
                    <path style="fill:#D1D1D1;" d="M390.401,144.762c-7.096-7.646-17.368-11.717-30.527-12.104c-37.152-1.2-63.426,18.566-78.091,58.733
                      c-0.769,2.11-0.3,4.451,1.226,6.106c1.517,1.645,3.796,2.301,5.947,1.71c4.22-1.16,8.401-1.746,12.435-1.746
                      c5.413,0,12.621,0.995,16.208,5.735c2.75,3.641,3.125,9.097,1.11,16.219c-1.698,6.011-10.449,22.097-21.28,39.117
                      c-13.195,20.739-20.482,30.036-22.585,30.036c-3.587,0-12.007-29.625-19.42-58.675v148.599
                      c24.426-4.613,53.212-27.479,89.219-74.342c36.788-47.875,56.489-85.845,57.751-113.473
                      C403.346,169.817,399.31,154.365,390.401,144.762z"/>
                  </svg>
                </div>
                <div *ngIf="videoType == 3" class="icone">
                  <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                      viewBox="0 0 112.196 112.196" style="enable-background:new 0 0 112.196 112.196;" xml:space="preserve">
                    <g>
                      <circle style="fill:#3B5998;" cx="56.098" cy="56.098" r="56.098"/>
                      <path style="fill:#FFFFFF;" d="M70.201,58.294h-10.01v36.672H45.025V58.294h-7.213V45.406h7.213v-8.34
                        c0-5.964,2.833-15.303,15.301-15.303L71.56,21.81v12.51h-8.151c-1.337,0-3.217,0.668-3.217,3.513v7.585h11.334L70.201,58.294z"/>
                    </g>
                  </svg>
                </div>
                <div *ngIf="videoType == 4" class="icone">
                  <svg height="512" viewBox="0 0 128 128" width="512" xmlns="http://www.w3.org/2000/svg"><g id="number"><text fill="#24253a" font-family="MyriadPro-Regular, Myriad Pro" font-size="40" letter-spacing=".002em" transform="translate(61.012 -738.265)">8<tspan x="-10.3" y="228">18</tspan><tspan x="-10.3" y="456">28</tspan><tspan x="-10.3" y="684">38</tspan><tspan x="-10.3" y="912">48</tspan><tspan x="-10.3" y="1140">58</tspan><tspan x="-10.3" y="1368">68</tspan><tspan x="-10.3" y="1596">78</tspan><tspan x="-10.3" y="1824">88</tspan><tspan x="-10.3" y="2052">98</tspan><tspan x="-20.599" y="2280">108</tspan><tspan x="-20.599" y="2508">118</tspan><tspan x="-20.599" y="2736">128</tspan><tspan x="-20.599" y="2964">138</tspan><tspan x="-20.599" y="3192">148</tspan><tspan x="-20.599" y="3420">158</tspan><tspan x="-20.599" y="3648">168</tspan><tspan x="-20.599" y="3876">178</tspan><tspan x="-20.599" y="4104">188</tspan><tspan x="-20.599" y="4332">198</tspan><tspan x="-20.599" y="4560">208</tspan><tspan x="-20.599" y="4788">218</tspan><tspan x="-20.599" y="5016">228</tspan><tspan x="-20.599" y="5244">238</tspan><tspan x="-20.599" y="5472">248</tspan></text></g><g id="Circle_Grid" data-name="Circle Grid"><circle cx="64" cy="64" fill="#f6c863" r="64"/></g><g id="icon"><path d="m29.587 36.85h68.83a1.645 1.645 0 0 1 1.645 1.645v48.54a0 0 0 0 1 0 0h-72.12a0 0 0 0 1 0 0v-48.535a1.645 1.645 0 0 1 1.645-1.65z" fill="#575b6d"/><path d="m45.08 27.939h37.845v63.894h-37.845z" fill="#69b0ee" transform="matrix(0 1 -1 0 123.889 -4.116)"/><path d="m105 83.922v1.609a5.618 5.618 0 0 1 -1.645 3.972 5.618 5.618 0 0 1 -3.972 1.645h-70.783a5.572 5.572 0 0 1 -3.944-1.636l-.03-.03a5.572 5.572 0 0 1 -1.626-3.934v-1.626a1 1 0 0 1 1-1h31.983a.411.411 0 0 1 .411.411 3.291 3.291 0 0 0 3.291 3.291h8.639a3.291 3.291 0 0 0 3.291-3.291.411.411 0 0 1 .411-.411h31.974a1 1 0 0 1 1 1z" fill="#414451"/><g fill="#eeefee"><path d="m77.172 40.96-13.125 37.85h-1.74l13.125-37.85z" opacity=".5"/><path d="m70.196 40.96-13.125 37.85h-6.243l13.125-37.85z" opacity=".5"/></g></g></svg>
                </div>
                <input
                  type="text"
                  placeholder="Code de la vidéo"
                  [(ngModel)]="videoCode"
                />
                <div class="delete" (click)="onDeleteVideo(video)">
                  <svg height="329pt" viewBox="0 0 329.26933 329" width="329pt" xmlns="http://www.w3.org/2000/svg"><path d="m194.800781 164.769531 128.210938-128.214843c8.34375-8.339844 8.34375-21.824219 0-30.164063-8.339844-8.339844-21.824219-8.339844-30.164063 0l-128.214844 128.214844-128.210937-128.214844c-8.34375-8.339844-21.824219-8.339844-30.164063 0-8.34375 8.339844-8.34375 21.824219 0 30.164063l128.210938 128.214843-128.210938 128.214844c-8.34375 8.339844-8.34375 21.824219 0 30.164063 4.15625 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921875-2.089844 15.082031-6.25l128.210937-128.214844 128.214844 128.214844c4.160156 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921874-2.089844 15.082031-6.25 8.34375-8.339844 8.34375-21.824219 0-30.164063zm0 0"/>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="url">
          <div class="perso full-width">
            <div class="input-title">
              URL liée
            </div>
            <div class="input">
              <input
                type="text"
                placeholder="Lien"
                [(ngModel)]="pointUrl"
                />
            </div>
          </div>
        </div>
        <div class="lat-lon">
          <div class="perso" style="margin-right: 10px">
            <div class="input-title">
              Latitude
            </div>
            <div class="input">
              <input
                type="text"
                placeholder="Lien"
                [(ngModel)]="point.lat"
                />
            </div>
          </div>
          <div class="perso" style="margin-left: 10px">
            <div class="input-title">
              Longitude
            </div>
            <div class="input">
              <input
                type="text"
                placeholder="Lien"
                [(ngModel)]="point.lon"
                />
            </div>
          </div>
        </div>
      </div>
      <div class="validation">
        <a style="cursor:pointer;" (click)="savePoint()" *ngIf="this.type == 'point'" [ngClass]="{'disabled' : !title}">
          Valider
        </a>
        <a style="cursor:pointer;" (click)="saveVariation()" *ngIf="this.type == 'variation'" [ngClass]="{'disabled' : !title}">
          Valider
        </a>
      </div>
    </div>
  </div>
</div>